// extracted by mini-css-extract-plugin
module.exports = {"rich-text-editor":"_142IODkNuVEPo7g2SL3Zad"};